import _ from 'lodash'
import { formatDisplay } from './generateDisplayFormat'
import fmtSeries from './fmtSeries'

// 默认的 markline 样式
const MARKLINE_DEFAULT_OPTIONS = {
  silent: false,
  animation: false,
  symbolSize: [0, 0],
  lineStyle: {
    normal: {
      type: 'dashed',
      width: '1',
      color: '#41dfe3',
    },
    emphasis: {
      type: 'dashed',
      width: '1',
      color: '#41dfe3',
    }
  },
  label: {
    normal: {
      show: true,
      position: 'middle',
      formatter: '{b}'
    },
    emphasis: {
      show: true,
      position: 'middle',
      formatter: '{b}'
    }
  },
  data: []
}

// symbol 样式
const MARKLINE_SYMBOL = {
  symbol: 'path://M716.8 25.6v665.6l-204.8 307.2-204.8-307.2V25.6z',
  symbolSize: [8, 15]
}

const Z_MARKLINE_SYMBOL = {
  symbol: [null, 'path://M716.8 25.6v665.6l-204.8 307.2-204.8-307.2V25.6z'],
  symbolSize: [8, 15]
}

// 合并
const mergeMarklineOpts = function (markline, opts) {
  if (opts) {
    markline.lineStyle.normal.type = opts.style
    markline.lineStyle.normal.width = opts.width
    markline.lineStyle.normal.color = opts.color

    markline.lineStyle.emphasis.type = opts.style
    markline.lineStyle.emphasis.width = opts.width
    markline.lineStyle.emphasis.color = opts.color

    markline.label.normal.show = opts.show
    markline.label.emphasis.show = opts.show

    const data = opts.data || []
    data.forEach((item) => {
      const { config } = item
      const target = markline.data.find(m => m.name && m.name.indexOf(item.name) === 0)
      if (config && target) {
        target.lineStyle = {
          normal: {
            type: config.style,
            width: config.width,
            color: config.color
          },
          emphasis: {
            type: config.style,
            width: config.width,
            color: config.color
          }
        }
      }
    })
  }
}

export default function markLine(option, _markLine, HORIZON = false, displayFormat = null, zaxisFormat = null) {
  // 辅助线 相关数据
  const { data } = _markLine

  if (Array.isArray(option.series)) {
    // x、y轴
    const markLine_data = []
    // z轴
    const z_markLine_data = []

    Array.isArray(data) && data.forEach((item) => {
      if (item.value !== '' && !Number.isNaN(+item.value)) {
        // 数值
        const value = Number.isSafeInteger(+item.value) ? +item.value : fmtSeries(+item.value)
        // 格式化后的显示
        let fmt_value = value

        if (item.axis_type === 1 && displayFormat) {
          fmt_value = formatDisplay(value, displayFormat)
        } else if (item.axis_type === 2 && zaxisFormat) {
          fmt_value = formatDisplay(value, zaxisFormat)
        }

        const marklineData = {
          ...MARKLINE_SYMBOL,
          name: `${item.name}: ${fmt_value}`
        }

        HORIZON ? Object.assign(marklineData, {
          xAxis: value
        }) : Object.assign(marklineData, {
          yAxis: value
        })

        if (item.axis_type === 2) {
          z_markLine_data.push(marklineData)
        } else {
          markLine_data.push(marklineData)
        }
      }
    })

    if (option.series[0]) {
      option.series[0].markLine = {
        ..._.cloneDeep(MARKLINE_DEFAULT_OPTIONS),
        data: markLine_data
      }

      // x 轴
      if (HORIZON) {
        mergeMarklineOpts(option.series[0].markLine, _markLine.x)
      } else {
        mergeMarklineOpts(option.series[0].markLine, _markLine.y)
      }
    }
    let zIndex = 1
    option.series.forEach((s, index) => {
      if (s.yAxisIndex === 1) {
        zIndex = index
      }
    })
    if (option.series[zIndex] && z_markLine_data.length > 0 && _markLine.$el) {
      const markline_data = []

      z_markLine_data.forEach((item) => {
        markline_data.push({
          yAxis: item.yAxis,
          name: item.name
        })
      })

      option.series[zIndex].markLine = {
        ..._.cloneDeep(MARKLINE_DEFAULT_OPTIONS),
        ...Z_MARKLINE_SYMBOL,
        data: markline_data
      }

      mergeMarklineOpts(option.series[zIndex].markLine, _markLine.z)
    }
  }
  return option
}
